/** Customer stories — country names & photo captions (18 languages) */
export const customerStoryTranslations = {
  zh: {
    customerStoryCountryUsaNewYork: "美国纽约",
    customerStoryCountryGermany: "德国",
    customerStoryCountryThailand: "泰国",
    customerStoryCountrySpain: "西班牙",
    customerStoryCountryBrazil: "巴西",
    customerStoryCountryAustralia: "澳洲",
    customerStoryCountrySaudiArabia: "沙特",
    customerStoryCountrySingapore: "新加坡",
    customerStoryCountryKorea: "韩国",
    customerStoryCountryIsrael: "以色列",
    customerStoryCountryKazakhstan: "哈萨克斯坦",
    customerStoryCountryMexico: "墨西哥",
    customerStoryCountryArgentina: "阿根廷",
    customerStoryCountryPhilippines: "菲律宾",
    customerStoryCountryIndonesia: "印尼",
    customerStoryCountryNetherlands: "荷兰",
    customerStoryCountrySweden: "瑞典",
    customerStoryCountrySouthAfrica: "南非",
    customerStoryCountryMalaysia: "马来西亚",
    customerStoryCountryTaiwan: "中国台湾",
    customerStoryCountryUsa: "美国",
    customerStoryCountryCambodia: "柬埔寨",
    customerStoryCountryCanada: "加拿大",
    customerStoryCaption01: "美国｜6090 UV Printer",
    customerStoryCaption02: "德国｜F33 DTF Printer",
    customerStoryCaption03: "泰国｜3250 UV Printer",
    customerStoryCaption04: "西班牙｜3250 UV Printer",
    customerStoryCaption05: "巴西｜2030 UV Printer",
    customerStoryCaption06: "澳洲｜F33 DTF Printer",
    customerStoryCaption07: "沙特｜2030 UV Printer",
    customerStoryCaption08: "新加坡｜F33 DTF Printer",
    customerStoryCaption09: "韩国｜F33 DTF Printer",
    customerStoryCaption10: "以色列｜UVC33 DTF Printer",
    customerStoryCaption11: "哈萨克斯坦｜4030 UV Printer",
    customerStoryCaption12: "墨西哥｜4060 UV Printer",
    customerStoryCaption13: "阿根廷｜4060 UV Printer",
    customerStoryCaption14: "菲律宾｜6090 UV Printer",
    customerStoryCaption15: "印尼｜4030 UV Printer",
    customerStoryCaption16: "荷兰｜4030 UV Printer",
    customerStoryCaption17: "瑞典｜4060 UV Printer",
    customerStoryCaption18: "德国｜2030 UV Printer",
    customerStoryCaption19: "南非｜2030 UV Printer",
    customerStoryCaption20: "马来西亚｜F33 DTF Printer",
    customerStoryCaption21: "中国台湾｜UVC33 DTF Printer",
    customerStoryCaption22: "美国｜F70Pro DTF Printer",
    customerStoryCaption23: "美国｜2513 UV Printer",
    customerStoryCaption24: "美国｜6090 UV Printer",
    customerStoryCaption25: "美国｜4030 UV Printer",
    customerStoryCaption26: "美国｜3250 UV Printer",
    customerStoryCaption27: "韩国｜4060 UV Printer",
    customerStoryCaption28: "荷兰｜4060 UV Printer",
    customerStoryCaption29: "柬埔寨｜4030 UV Printer",
    customerStoryCaption30: "加拿大｜F33 DTF Printer",
  },
  en: {
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCountryCambodia: "Cambodia",
    customerStoryCountryCanada: "Canada",
    customerStoryCaption01: "United States｜6090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand｜3250 UV Printer",
    customerStoryCaption04: "Spain｜3250 UV Printer",
    customerStoryCaption05: "Brazil｜2030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia｜2030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan｜4030 UV Printer",
    customerStoryCaption12: "Mexico｜4060 UV Printer",
    customerStoryCaption13: "Argentina｜4060 UV Printer",
    customerStoryCaption14: "Philippines｜6090 UV Printer",
    customerStoryCaption15: "Indonesia｜4030 UV Printer",
    customerStoryCaption16: "Netherlands｜4030 UV Printer",
    customerStoryCaption17: "Sweden｜4060 UV Printer",
    customerStoryCaption18: "Germany｜2030 UV Printer",
    customerStoryCaption19: "South Africa｜2030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "United States｜F70Pro DTF Printer",
    customerStoryCaption23: "United States｜2513 UV Printer",
    customerStoryCaption24: "United States｜6090 UV Printer",
    customerStoryCaption25: "United States｜4030 UV Printer",
    customerStoryCaption26: "United States｜3250 UV Printer",
    customerStoryCaption27: "South Korea｜4060 UV Printer",
    customerStoryCaption28: "Netherlands｜4060 UV Printer",
    customerStoryCaption29: "Cambodia｜4030 UV Printer",
    customerStoryCaption30: "Canada｜F33 DTF Printer",
  },
  de: {
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Deutschland",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spanien",
    customerStoryCountryBrazil: "Brasilien",
    customerStoryCountryAustralia: "Australien",
    customerStoryCountrySaudiArabia: "Saudi-Arabien",
    customerStoryCountrySingapore: "Singapur",
    customerStoryCountryKorea: "Südkorea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kasachstan",
    customerStoryCountryMexico: "Mexiko",
    customerStoryCountryArgentina: "Argentinien",
    customerStoryCountryPhilippines: "Philippinen",
    customerStoryCountryIndonesia: "Indonesien",
    customerStoryCountryNetherlands: "Niederlande",
    customerStoryCountrySweden: "Schweden",
    customerStoryCountrySouthAfrica: "Südafrika",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "Vereinigte Staaten",
    customerStoryCountryCambodia: "Kambodscha",
    customerStoryCountryCanada: "Kanada",
    customerStoryCaption01: "Vereinigte Staaten｜6090 UV Printer",
    customerStoryCaption02: "Deutschland｜F33 DTF Printer",
    customerStoryCaption03: "Thailand｜3250 UV Printer",
    customerStoryCaption04: "Spanien｜3250 UV Printer",
    customerStoryCaption05: "Brasilien｜2030 UV Printer",
    customerStoryCaption06: "Australien｜F33 DTF Printer",
    customerStoryCaption07: "Saudi-Arabien｜2030 UV Printer",
    customerStoryCaption08: "Singapur｜F33 DTF Printer",
    customerStoryCaption09: "Südkorea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kasachstan｜4030 UV Printer",
    customerStoryCaption12: "Mexiko｜4060 UV Printer",
    customerStoryCaption13: "Argentinien｜4060 UV Printer",
    customerStoryCaption14: "Philippinen｜6090 UV Printer",
    customerStoryCaption15: "Indonesien｜4030 UV Printer",
    customerStoryCaption16: "Niederlande｜4030 UV Printer",
    customerStoryCaption17: "Schweden｜4060 UV Printer",
    customerStoryCaption18: "Deutschland｜2030 UV Printer",
    customerStoryCaption19: "Südafrika｜2030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "Vereinigte Staaten｜F70Pro DTF Printer",
    customerStoryCaption23: "Vereinigte Staaten｜2513 UV Printer",
    customerStoryCaption24: "Vereinigte Staaten｜6090 UV Printer",
    customerStoryCaption25: "Vereinigte Staaten｜4030 UV Printer",
    customerStoryCaption26: "Vereinigte Staaten｜3250 UV Printer",
    customerStoryCaption27: "Südkorea｜4060 UV Printer",
    customerStoryCaption28: "Niederlande｜4060 UV Printer",
    customerStoryCaption29: "Kambodscha｜4030 UV Printer",
    customerStoryCaption30: "Kanada｜F33 DTF Printer",
  },
  pt: {
    customerStoryCountryUsaNewYork: "Nova York, EUA",
    customerStoryCountryGermany: "Alemanha",
    customerStoryCountryThailand: "Tailândia",
    customerStoryCountrySpain: "Espanha",
    customerStoryCountryBrazil: "Brasil",
    customerStoryCountryAustralia: "Austrália",
    customerStoryCountrySaudiArabia: "Arábia Saudita",
    customerStoryCountrySingapore: "Singapura",
    customerStoryCountryKorea: "Coreia do Sul",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Cazaquistão",
    customerStoryCountryMexico: "México",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Filipinas",
    customerStoryCountryIndonesia: "Indonésia",
    customerStoryCountryNetherlands: "Países Baixos",
    customerStoryCountrySweden: "Suécia",
    customerStoryCountrySouthAfrica: "África do Sul",
    customerStoryCountryMalaysia: "Malásia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "Estados Unidos",
    customerStoryCountryCambodia: "Camboja",
    customerStoryCountryCanada: "Canadá",
    customerStoryCaption01: "Estados Unidos｜6090 UV Printer",
    customerStoryCaption02: "Alemanha｜F33 DTF Printer",
    customerStoryCaption03: "Tailândia｜3250 UV Printer",
    customerStoryCaption04: "Espanha｜3250 UV Printer",
    customerStoryCaption05: "Brasil｜2030 UV Printer",
    customerStoryCaption06: "Austrália｜F33 DTF Printer",
    customerStoryCaption07: "Arábia Saudita｜2030 UV Printer",
    customerStoryCaption08: "Singapura｜F33 DTF Printer",
    customerStoryCaption09: "Coreia do Sul｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Cazaquistão｜4030 UV Printer",
    customerStoryCaption12: "México｜4060 UV Printer",
    customerStoryCaption13: "Argentina｜4060 UV Printer",
    customerStoryCaption14: "Filipinas｜6090 UV Printer",
    customerStoryCaption15: "Indonésia｜4030 UV Printer",
    customerStoryCaption16: "Países Baixos｜4030 UV Printer",
    customerStoryCaption17: "Suécia｜4060 UV Printer",
    customerStoryCaption18: "Alemanha｜2030 UV Printer",
    customerStoryCaption19: "África do Sul｜2030 UV Printer",
    customerStoryCaption20: "Malásia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "Estados Unidos｜F70Pro DTF Printer",
    customerStoryCaption23: "Estados Unidos｜2513 UV Printer",
    customerStoryCaption24: "Estados Unidos｜6090 UV Printer",
    customerStoryCaption25: "Estados Unidos｜4030 UV Printer",
    customerStoryCaption26: "Estados Unidos｜3250 UV Printer",
    customerStoryCaption27: "Coreia do Sul｜4060 UV Printer",
    customerStoryCaption28: "Países Baixos｜4060 UV Printer",
    customerStoryCaption29: "Camboja｜4030 UV Printer",
    customerStoryCaption30: "Canadá｜F33 DTF Printer",
  },
  es: {
    customerStoryCountryUsaNewYork: "Nueva York, EE. UU.",
    customerStoryCountryGermany: "Alemania",
    customerStoryCountryThailand: "Tailandia",
    customerStoryCountrySpain: "España",
    customerStoryCountryBrazil: "Brasil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Arabia Saudita",
    customerStoryCountrySingapore: "Singapur",
    customerStoryCountryKorea: "Corea del Sur",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazajistán",
    customerStoryCountryMexico: "México",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Filipinas",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Países Bajos",
    customerStoryCountrySweden: "Suecia",
    customerStoryCountrySouthAfrica: "Sudáfrica",
    customerStoryCountryMalaysia: "Malasia",
    customerStoryCountryTaiwan: "Taiwán",
    customerStoryCountryUsa: "Estados Unidos",
    customerStoryCountryCambodia: "Camboya",
    customerStoryCountryCanada: "Canadá",
    customerStoryCaption01: "Estados Unidos｜6090 UV Printer",
    customerStoryCaption02: "Alemania｜F33 DTF Printer",
    customerStoryCaption03: "Tailandia｜3250 UV Printer",
    customerStoryCaption04: "España｜3250 UV Printer",
    customerStoryCaption05: "Brasil｜2030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Arabia Saudita｜2030 UV Printer",
    customerStoryCaption08: "Singapur｜F33 DTF Printer",
    customerStoryCaption09: "Corea del Sur｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazajistán｜4030 UV Printer",
    customerStoryCaption12: "México｜4060 UV Printer",
    customerStoryCaption13: "Argentina｜4060 UV Printer",
    customerStoryCaption14: "Filipinas｜6090 UV Printer",
    customerStoryCaption15: "Indonesia｜4030 UV Printer",
    customerStoryCaption16: "Países Bajos｜4030 UV Printer",
    customerStoryCaption17: "Suecia｜4060 UV Printer",
    customerStoryCaption18: "Alemania｜2030 UV Printer",
    customerStoryCaption19: "Sudáfrica｜2030 UV Printer",
    customerStoryCaption20: "Malasia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwán｜UVC33 DTF Printer",
    customerStoryCaption22: "Estados Unidos｜F70Pro DTF Printer",
    customerStoryCaption23: "Estados Unidos｜2513 UV Printer",
    customerStoryCaption24: "Estados Unidos｜6090 UV Printer",
    customerStoryCaption25: "Estados Unidos｜4030 UV Printer",
    customerStoryCaption26: "Estados Unidos｜3250 UV Printer",
    customerStoryCaption27: "Corea del Sur｜4060 UV Printer",
    customerStoryCaption28: "Países Bajos｜4060 UV Printer",
    customerStoryCaption29: "Camboya｜4030 UV Printer",
    customerStoryCaption30: "Canadá｜F33 DTF Printer",
  },
  fr: {
    customerStoryCountryUsaNewYork: "New York, États-Unis",
    customerStoryCountryGermany: "Allemagne",
    customerStoryCountryThailand: "Thaïlande",
    customerStoryCountrySpain: "Espagne",
    customerStoryCountryBrazil: "Brésil",
    customerStoryCountryAustralia: "Australie",
    customerStoryCountrySaudiArabia: "Arabie saoudite",
    customerStoryCountrySingapore: "Singapour",
    customerStoryCountryKorea: "Corée du Sud",
    customerStoryCountryIsrael: "Israël",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexique",
    customerStoryCountryArgentina: "Argentine",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonésie",
    customerStoryCountryNetherlands: "Pays-Bas",
    customerStoryCountrySweden: "Suède",
    customerStoryCountrySouthAfrica: "Afrique du Sud",
    customerStoryCountryMalaysia: "Malaisie",
    customerStoryCountryTaiwan: "Taïwan",
    customerStoryCountryUsa: "États-Unis",
    customerStoryCountryCambodia: "Cambodge",
    customerStoryCountryCanada: "Canada",
    customerStoryCaption01: "États-Unis｜6090 UV Printer",
    customerStoryCaption02: "Allemagne｜F33 DTF Printer",
    customerStoryCaption03: "Thaïlande｜3250 UV Printer",
    customerStoryCaption04: "Espagne｜3250 UV Printer",
    customerStoryCaption05: "Brésil｜2030 UV Printer",
    customerStoryCaption06: "Australie｜F33 DTF Printer",
    customerStoryCaption07: "Arabie saoudite｜2030 UV Printer",
    customerStoryCaption08: "Singapour｜F33 DTF Printer",
    customerStoryCaption09: "Corée du Sud｜F33 DTF Printer",
    customerStoryCaption10: "Israël｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan｜4030 UV Printer",
    customerStoryCaption12: "Mexique｜4060 UV Printer",
    customerStoryCaption13: "Argentine｜4060 UV Printer",
    customerStoryCaption14: "Philippines｜6090 UV Printer",
    customerStoryCaption15: "Indonésie｜4030 UV Printer",
    customerStoryCaption16: "Pays-Bas｜4030 UV Printer",
    customerStoryCaption17: "Suède｜4060 UV Printer",
    customerStoryCaption18: "Allemagne｜2030 UV Printer",
    customerStoryCaption19: "Afrique du Sud｜2030 UV Printer",
    customerStoryCaption20: "Malaisie｜F33 DTF Printer",
    customerStoryCaption21: "Taïwan｜UVC33 DTF Printer",
    customerStoryCaption22: "États-Unis｜F70Pro DTF Printer",
    customerStoryCaption23: "États-Unis｜2513 UV Printer",
    customerStoryCaption24: "États-Unis｜6090 UV Printer",
    customerStoryCaption25: "États-Unis｜4030 UV Printer",
    customerStoryCaption26: "États-Unis｜3250 UV Printer",
    customerStoryCaption27: "Corée du Sud｜4060 UV Printer",
    customerStoryCaption28: "Pays-Bas｜4060 UV Printer",
    customerStoryCaption29: "Cambodge｜4030 UV Printer",
    customerStoryCaption30: "Canada｜F33 DTF Printer",
  },
  it: {
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germania",
    customerStoryCountryThailand: "Thailandia",
    customerStoryCountrySpain: "Spagna",
    customerStoryCountryBrazil: "Brasile",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Arabia Saudita",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "Corea del Sud",
    customerStoryCountryIsrael: "Israele",
    customerStoryCountryKazakhstan: "Kazakistan",
    customerStoryCountryMexico: "Messico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Filippine",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Paesi Bassi",
    customerStoryCountrySweden: "Svezia",
    customerStoryCountrySouthAfrica: "Sudafrica",
    customerStoryCountryMalaysia: "Malesia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "Stati Uniti",
    customerStoryCountryCambodia: "Cambogia",
    customerStoryCountryCanada: "Canada",
    customerStoryCaption01: "Stati Uniti｜6090 UV Printer",
    customerStoryCaption02: "Germania｜F33 DTF Printer",
    customerStoryCaption03: "Thailandia｜3250 UV Printer",
    customerStoryCaption04: "Spagna｜3250 UV Printer",
    customerStoryCaption05: "Brasile｜2030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Arabia Saudita｜2030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "Corea del Sud｜F33 DTF Printer",
    customerStoryCaption10: "Israele｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakistan｜4030 UV Printer",
    customerStoryCaption12: "Messico｜4060 UV Printer",
    customerStoryCaption13: "Argentina｜4060 UV Printer",
    customerStoryCaption14: "Filippine｜6090 UV Printer",
    customerStoryCaption15: "Indonesia｜4030 UV Printer",
    customerStoryCaption16: "Paesi Bassi｜4030 UV Printer",
    customerStoryCaption17: "Svezia｜4060 UV Printer",
    customerStoryCaption18: "Germania｜2030 UV Printer",
    customerStoryCaption19: "Sudafrica｜2030 UV Printer",
    customerStoryCaption20: "Malesia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "Stati Uniti｜F70Pro DTF Printer",
    customerStoryCaption23: "Stati Uniti｜2513 UV Printer",
    customerStoryCaption24: "Stati Uniti｜6090 UV Printer",
    customerStoryCaption25: "Stati Uniti｜4030 UV Printer",
    customerStoryCaption26: "Stati Uniti｜3250 UV Printer",
    customerStoryCaption27: "Corea del Sud｜4060 UV Printer",
    customerStoryCaption28: "Paesi Bassi｜4060 UV Printer",
    customerStoryCaption29: "Cambogia｜4030 UV Printer",
    customerStoryCaption30: "Canada｜F33 DTF Printer",
  },
  hi: {
    customerStoryCountryUsaNewYork: "न्यूयॉर्क, США",
    customerStoryCountryGermany: "जर्मनी",
    customerStoryCountryThailand: "थाईलैंड",
    customerStoryCountrySpain: "स्पेन",
    customerStoryCountryBrazil: "ब्राज़ील",
    customerStoryCountryAustralia: "ऑस्ट्रेलिया",
    customerStoryCountrySaudiArabia: "सऊदी अरब",
    customerStoryCountrySingapore: "सिंगापुर",
    customerStoryCountryKorea: "दक्षिण कोरिया",
    customerStoryCountryIsrael: "इज़राइल",
    customerStoryCountryKazakhstan: "कज़ाखस्तान",
    customerStoryCountryMexico: "मेक्सिको",
    customerStoryCountryArgentina: "अर्जेंटीना",
    customerStoryCountryPhilippines: "फिलीपींस",
    customerStoryCountryIndonesia: "इंडोनेशिया",
    customerStoryCountryNetherlands: "नीदरलैंड",
    customerStoryCountrySweden: "स्वीडन",
    customerStoryCountrySouthAfrica: "दक्षिण अफ़्रीका",
    customerStoryCountryMalaysia: "मलेशिया",
    customerStoryCountryTaiwan: "ताइवान",
    customerStoryCountryUsa: "संयुक्त राज्य अमेरिका",
    customerStoryCountryCambodia: "कंबोडिया",
    customerStoryCountryCanada: "कनाडा",
    customerStoryCaption01: "संयुक्त राज्य अमेरिका｜6090 UV Printer",
    customerStoryCaption02: "जर्मनी｜F33 DTF Printer",
    customerStoryCaption03: "थाईलैंड｜3250 UV Printer",
    customerStoryCaption04: "स्पेन｜3250 UV Printer",
    customerStoryCaption05: "ब्राज़ील｜2030 UV Printer",
    customerStoryCaption06: "ऑस्ट्रेलिया｜F33 DTF Printer",
    customerStoryCaption07: "सऊदी अरब｜2030 UV Printer",
    customerStoryCaption08: "सिंगापुर｜F33 DTF Printer",
    customerStoryCaption09: "दक्षिण कोरिया｜F33 DTF Printer",
    customerStoryCaption10: "इज़राइल｜UVC33 DTF Printer",
    customerStoryCaption11: "कज़ाखस्तान｜4030 UV Printer",
    customerStoryCaption12: "मेक्सिको｜4060 UV Printer",
    customerStoryCaption13: "अर्जेंटीना｜4060 UV Printer",
    customerStoryCaption14: "फिलीपींस｜6090 UV Printer",
    customerStoryCaption15: "इंडोनेशिया｜4030 UV Printer",
    customerStoryCaption16: "नीदरलैंड｜4030 UV Printer",
    customerStoryCaption17: "स्वीडन｜4060 UV Printer",
    customerStoryCaption18: "जर्मनी｜2030 UV Printer",
    customerStoryCaption19: "दक्षिण अफ़्रीका｜2030 UV Printer",
    customerStoryCaption20: "मलेशिया｜F33 DTF Printer",
    customerStoryCaption21: "ताइवान｜UVC33 DTF Printer",
    customerStoryCaption22: "संयुक्त राज्य अमेरिका｜F70Pro DTF Printer",
    customerStoryCaption23: "संयुक्त राज्य अमेरिका｜2513 UV Printer",
    customerStoryCaption24: "संयुक्त राज्य अमेरिका｜6090 UV Printer",
    customerStoryCaption25: "संयुक्त राज्य अमेरिका｜4030 UV Printer",
    customerStoryCaption26: "संयुक्त राज्य अमेरिका｜3250 UV Printer",
    customerStoryCaption27: "दक्षिण कोरिया｜4060 UV Printer",
    customerStoryCaption28: "नीदरलैंड｜4060 UV Printer",
    customerStoryCaption29: "कंबोडिया｜4030 UV Printer",
    customerStoryCaption30: "कनाडा｜F33 DTF Printer",
  },
  ru: {
    customerStoryCountryUsaNewYork: "Нью-Йорк, США",
    customerStoryCountryGermany: "Германия",
    customerStoryCountryThailand: "Таиланд",
    customerStoryCountrySpain: "Испания",
    customerStoryCountryBrazil: "Бразилия",
    customerStoryCountryAustralia: "Австралия",
    customerStoryCountrySaudiArabia: "Саудовская Аравия",
    customerStoryCountrySingapore: "Сингапур",
    customerStoryCountryKorea: "Южная Корея",
    customerStoryCountryIsrael: "Израиль",
    customerStoryCountryKazakhstan: "Казахстан",
    customerStoryCountryMexico: "Мексика",
    customerStoryCountryArgentina: "Аргентина",
    customerStoryCountryPhilippines: "Филиппины",
    customerStoryCountryIndonesia: "Индонезия",
    customerStoryCountryNetherlands: "Нидерланды",
    customerStoryCountrySweden: "Швеция",
    customerStoryCountrySouthAfrica: "ЮАР",
    customerStoryCountryMalaysia: "Малайзия",
    customerStoryCountryTaiwan: "Тайвань",
    customerStoryCountryUsa: "США",
    customerStoryCountryCambodia: "Камбоджа",
    customerStoryCountryCanada: "Канада",
    customerStoryCaption01: "США｜6090 UV Printer",
    customerStoryCaption02: "Германия｜F33 DTF Printer",
    customerStoryCaption03: "Таиланд｜3250 UV Printer",
    customerStoryCaption04: "Испания｜3250 UV Printer",
    customerStoryCaption05: "Бразилия｜2030 UV Printer",
    customerStoryCaption06: "Австралия｜F33 DTF Printer",
    customerStoryCaption07: "Саудовская Аравия｜2030 UV Printer",
    customerStoryCaption08: "Сингапур｜F33 DTF Printer",
    customerStoryCaption09: "Южная Корея｜F33 DTF Printer",
    customerStoryCaption10: "Израиль｜UVC33 DTF Printer",
    customerStoryCaption11: "Казахстан｜4030 UV Printer",
    customerStoryCaption12: "Мексика｜4060 UV Printer",
    customerStoryCaption13: "Аргентина｜4060 UV Printer",
    customerStoryCaption14: "Филиппины｜6090 UV Printer",
    customerStoryCaption15: "Индонезия｜4030 UV Printer",
    customerStoryCaption16: "Нидерланды｜4030 UV Printer",
    customerStoryCaption17: "Швеция｜4060 UV Printer",
    customerStoryCaption18: "Германия｜2030 UV Printer",
    customerStoryCaption19: "ЮАР｜2030 UV Printer",
    customerStoryCaption20: "Малайзия｜F33 DTF Printer",
    customerStoryCaption21: "Тайвань｜UVC33 DTF Printer",
    customerStoryCaption22: "США｜F70Pro DTF Printer",
    customerStoryCaption23: "США｜2513 UV Printer",
    customerStoryCaption24: "США｜6090 UV Printer",
    customerStoryCaption25: "США｜4030 UV Printer",
    customerStoryCaption26: "США｜3250 UV Printer",
    customerStoryCaption27: "Южная Корея｜4060 UV Printer",
    customerStoryCaption28: "Нидерланды｜4060 UV Printer",
    customerStoryCaption29: "Камбоджа｜4030 UV Printer",
    customerStoryCaption30: "Канада｜F33 DTF Printer",
  },
  ko: {
    customerStoryCountryUsaNewYork: "미국 뉴욕",
    customerStoryCountryGermany: "독일",
    customerStoryCountryThailand: "태국",
    customerStoryCountrySpain: "스페인",
    customerStoryCountryBrazil: "브라질",
    customerStoryCountryAustralia: "호주",
    customerStoryCountrySaudiArabia: "사우디아라비아",
    customerStoryCountrySingapore: "싱가포르",
    customerStoryCountryKorea: "한국",
    customerStoryCountryIsrael: "이스라엘",
    customerStoryCountryKazakhstan: "카자흐스탄",
    customerStoryCountryMexico: "멕시코",
    customerStoryCountryArgentina: "아르헨티나",
    customerStoryCountryPhilippines: "필리핀",
    customerStoryCountryIndonesia: "인도네시아",
    customerStoryCountryNetherlands: "네덜란드",
    customerStoryCountrySweden: "스웨덴",
    customerStoryCountrySouthAfrica: "남아프리카",
    customerStoryCountryMalaysia: "말레이시아",
    customerStoryCountryTaiwan: "대만",
    customerStoryCountryUsa: "미국",
    customerStoryCountryCambodia: "캄보디아",
    customerStoryCountryCanada: "캐나다",
    customerStoryCaption01: "미국｜6090 UV Printer",
    customerStoryCaption02: "독일｜F33 DTF Printer",
    customerStoryCaption03: "태국｜3250 UV Printer",
    customerStoryCaption04: "스페인｜3250 UV Printer",
    customerStoryCaption05: "브라질｜2030 UV Printer",
    customerStoryCaption06: "호주｜F33 DTF Printer",
    customerStoryCaption07: "사우디아라비아｜2030 UV Printer",
    customerStoryCaption08: "싱가포르｜F33 DTF Printer",
    customerStoryCaption09: "한국｜F33 DTF Printer",
    customerStoryCaption10: "이스라엘｜UVC33 DTF Printer",
    customerStoryCaption11: "카자흐스탄｜4030 UV Printer",
    customerStoryCaption12: "멕시코｜4060 UV Printer",
    customerStoryCaption13: "아르헨티나｜4060 UV Printer",
    customerStoryCaption14: "필리핀｜6090 UV Printer",
    customerStoryCaption15: "인도네시아｜4030 UV Printer",
    customerStoryCaption16: "네덜란드｜4030 UV Printer",
    customerStoryCaption17: "스웨덴｜4060 UV Printer",
    customerStoryCaption18: "독일｜2030 UV Printer",
    customerStoryCaption19: "남아프리카｜2030 UV Printer",
    customerStoryCaption20: "말레이시아｜F33 DTF Printer",
    customerStoryCaption21: "대만｜UVC33 DTF Printer",
    customerStoryCaption22: "미국｜F70Pro DTF Printer",
    customerStoryCaption23: "미국｜2513 UV Printer",
    customerStoryCaption24: "미국｜6090 UV Printer",
    customerStoryCaption25: "미국｜4030 UV Printer",
    customerStoryCaption26: "미국｜3250 UV Printer",
    customerStoryCaption27: "한국｜4060 UV Printer",
    customerStoryCaption28: "네덜란드｜4060 UV Printer",
    customerStoryCaption29: "캄보디아｜4030 UV Printer",
    customerStoryCaption30: "캐나다｜F33 DTF Printer",
  },
  ja: {
    customerStoryCountryUsaNewYork: "アメリカ・ニューヨーク",
    customerStoryCountryGermany: "ドイツ",
    customerStoryCountryThailand: "タイ",
    customerStoryCountrySpain: "スペイン",
    customerStoryCountryBrazil: "ブラジル",
    customerStoryCountryAustralia: "オーストラリア",
    customerStoryCountrySaudiArabia: "サウジアラビア",
    customerStoryCountrySingapore: "シンガポール",
    customerStoryCountryKorea: "韓国",
    customerStoryCountryIsrael: "イスラエル",
    customerStoryCountryKazakhstan: "カザフスタン",
    customerStoryCountryMexico: "メキシコ",
    customerStoryCountryArgentina: "アルゼンチン",
    customerStoryCountryPhilippines: "フィリピン",
    customerStoryCountryIndonesia: "インドネシア",
    customerStoryCountryNetherlands: "オランダ",
    customerStoryCountrySweden: "スウェーデン",
    customerStoryCountrySouthAfrica: "南アフリカ",
    customerStoryCountryMalaysia: "マレーシア",
    customerStoryCountryTaiwan: "台湾",
    customerStoryCountryUsa: "アメリカ",
    customerStoryCountryCambodia: "カンボジア",
    customerStoryCountryCanada: "カナダ",
    customerStoryCaption01: "アメリカ｜6090 UV Printer",
    customerStoryCaption02: "ドイツ｜F33 DTF Printer",
    customerStoryCaption03: "タイ｜3250 UV Printer",
    customerStoryCaption04: "スペイン｜3250 UV Printer",
    customerStoryCaption05: "ブラジル｜2030 UV Printer",
    customerStoryCaption06: "オーストラリア｜F33 DTF Printer",
    customerStoryCaption07: "サウジアラビア｜2030 UV Printer",
    customerStoryCaption08: "シンガポール｜F33 DTF Printer",
    customerStoryCaption09: "韓国｜F33 DTF Printer",
    customerStoryCaption10: "イスラエル｜UVC33 DTF Printer",
    customerStoryCaption11: "カザフスタン｜4030 UV Printer",
    customerStoryCaption12: "メキシコ｜4060 UV Printer",
    customerStoryCaption13: "アルゼンチン｜4060 UV Printer",
    customerStoryCaption14: "フィリピン｜6090 UV Printer",
    customerStoryCaption15: "インドネシア｜4030 UV Printer",
    customerStoryCaption16: "オランダ｜4030 UV Printer",
    customerStoryCaption17: "スウェーデン｜4060 UV Printer",
    customerStoryCaption18: "ドイツ｜2030 UV Printer",
    customerStoryCaption19: "南アフリカ｜2030 UV Printer",
    customerStoryCaption20: "マレーシア｜F33 DTF Printer",
    customerStoryCaption21: "台湾｜UVC33 DTF Printer",
    customerStoryCaption22: "アメリカ｜F70Pro DTF Printer",
    customerStoryCaption23: "アメリカ｜2513 UV Printer",
    customerStoryCaption24: "アメリカ｜6090 UV Printer",
    customerStoryCaption25: "アメリカ｜4030 UV Printer",
    customerStoryCaption26: "アメリカ｜3250 UV Printer",
    customerStoryCaption27: "韓国｜4060 UV Printer",
    customerStoryCaption28: "オランダ｜4060 UV Printer",
    customerStoryCaption29: "カンボジア｜4030 UV Printer",
    customerStoryCaption30: "カナダ｜F33 DTF Printer",
  },
  th: {
    customerStoryCountryUsaNewYork: "นิวยอร์ก สหรัฐอเมริกา",
    customerStoryCountryGermany: "เยอรมนี",
    customerStoryCountryThailand: "ไทย",
    customerStoryCountrySpain: "สเปน",
    customerStoryCountryBrazil: "บราซิล",
    customerStoryCountryAustralia: "ออสเตรเลีย",
    customerStoryCountrySaudiArabia: "ซาอุดีอาระเบีย",
    customerStoryCountrySingapore: "สิงคโปร์",
    customerStoryCountryKorea: "เกาหลีใต้",
    customerStoryCountryIsrael: "อิสราเอล",
    customerStoryCountryKazakhstan: "คาซัคสถาน",
    customerStoryCountryMexico: "เม็กซิโก",
    customerStoryCountryArgentina: "อาร์เจนตินา",
    customerStoryCountryPhilippines: "ฟิลิปปินส์",
    customerStoryCountryIndonesia: "อินโดนีเซีย",
    customerStoryCountryNetherlands: "เนเธอร์แลนด์",
    customerStoryCountrySweden: "สวีเดน",
    customerStoryCountrySouthAfrica: "แอฟริกาใต้",
    customerStoryCountryMalaysia: "มาเลเซีย",
    customerStoryCountryTaiwan: "ไต้หวัน",
    customerStoryCountryUsa: "สหรัฐอเมริกา",
    customerStoryCountryCambodia: "กัมพูชา",
    customerStoryCountryCanada: "แคนาดา",
    customerStoryCaption01: "สหรัฐอเมริกา｜6090 UV Printer",
    customerStoryCaption02: "เยอรมนี｜F33 DTF Printer",
    customerStoryCaption03: "ไทย｜3250 UV Printer",
    customerStoryCaption04: "สเปน｜3250 UV Printer",
    customerStoryCaption05: "บราซิล｜2030 UV Printer",
    customerStoryCaption06: "ออสเตรเลีย｜F33 DTF Printer",
    customerStoryCaption07: "ซาอุดีอาระเบีย｜2030 UV Printer",
    customerStoryCaption08: "สิงคโปร์｜F33 DTF Printer",
    customerStoryCaption09: "เกาหลีใต้｜F33 DTF Printer",
    customerStoryCaption10: "อิสราเอล｜UVC33 DTF Printer",
    customerStoryCaption11: "คาซัคสถาน｜4030 UV Printer",
    customerStoryCaption12: "เม็กซิโก｜4060 UV Printer",
    customerStoryCaption13: "อาร์เจนตินา｜4060 UV Printer",
    customerStoryCaption14: "ฟิลิปปินส์｜6090 UV Printer",
    customerStoryCaption15: "อินโดนีเซีย｜4030 UV Printer",
    customerStoryCaption16: "เนเธอร์แลนด์｜4030 UV Printer",
    customerStoryCaption17: "สวีเดน｜4060 UV Printer",
    customerStoryCaption18: "เยอรมนี｜2030 UV Printer",
    customerStoryCaption19: "แอฟริกาใต้｜2030 UV Printer",
    customerStoryCaption20: "มาเลเซีย｜F33 DTF Printer",
    customerStoryCaption21: "ไต้หวัน｜UVC33 DTF Printer",
    customerStoryCaption22: "สหรัฐอเมริกา｜F70Pro DTF Printer",
    customerStoryCaption23: "สหรัฐอเมริกา｜2513 UV Printer",
    customerStoryCaption24: "สหรัฐอเมริกา｜6090 UV Printer",
    customerStoryCaption25: "สหรัฐอเมริกา｜4030 UV Printer",
    customerStoryCaption26: "สหรัฐอเมริกา｜3250 UV Printer",
    customerStoryCaption27: "เกาหลีใต้｜4060 UV Printer",
    customerStoryCaption28: "เนเธอร์แลนด์｜4060 UV Printer",
    customerStoryCaption29: "กัมพูชา｜4030 UV Printer",
    customerStoryCaption30: "แคนาดา｜F33 DTF Printer",
  },
  tr: {
    customerStoryCountryUsaNewYork: "New York, ABD",
    customerStoryCountryGermany: "Almanya",
    customerStoryCountryThailand: "Tayland",
    customerStoryCountrySpain: "İspanya",
    customerStoryCountryBrazil: "Brezilya",
    customerStoryCountryAustralia: "Avustralya",
    customerStoryCountrySaudiArabia: "Suudi Arabistan",
    customerStoryCountrySingapore: "Singapur",
    customerStoryCountryKorea: "Güney Kore",
    customerStoryCountryIsrael: "İsrail",
    customerStoryCountryKazakhstan: "Kazakistan",
    customerStoryCountryMexico: "Meksika",
    customerStoryCountryArgentina: "Arjantin",
    customerStoryCountryPhilippines: "Filipinler",
    customerStoryCountryIndonesia: "Endonezya",
    customerStoryCountryNetherlands: "Hollanda",
    customerStoryCountrySweden: "İsveç",
    customerStoryCountrySouthAfrica: "Güney Afrika",
    customerStoryCountryMalaysia: "Malezya",
    customerStoryCountryTaiwan: "Tayvan",
    customerStoryCountryUsa: "Amerika Birleşik Devletleri",
    customerStoryCountryCambodia: "Kamboçya",
    customerStoryCountryCanada: "Kanada",
    customerStoryCaption01: "Amerika Birleşik Devletleri｜6090 UV Printer",
    customerStoryCaption02: "Almanya｜F33 DTF Printer",
    customerStoryCaption03: "Tayland｜3250 UV Printer",
    customerStoryCaption04: "İspanya｜3250 UV Printer",
    customerStoryCaption05: "Brezilya｜2030 UV Printer",
    customerStoryCaption06: "Avustralya｜F33 DTF Printer",
    customerStoryCaption07: "Suudi Arabistan｜2030 UV Printer",
    customerStoryCaption08: "Singapur｜F33 DTF Printer",
    customerStoryCaption09: "Güney Kore｜F33 DTF Printer",
    customerStoryCaption10: "İsrail｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakistan｜4030 UV Printer",
    customerStoryCaption12: "Meksika｜4060 UV Printer",
    customerStoryCaption13: "Arjantin｜4060 UV Printer",
    customerStoryCaption14: "Filipinler｜6090 UV Printer",
    customerStoryCaption15: "Endonezya｜4030 UV Printer",
    customerStoryCaption16: "Hollanda｜4030 UV Printer",
    customerStoryCaption17: "İsveç｜4060 UV Printer",
    customerStoryCaption18: "Almanya｜2030 UV Printer",
    customerStoryCaption19: "Güney Afrika｜2030 UV Printer",
    customerStoryCaption20: "Malezya｜F33 DTF Printer",
    customerStoryCaption21: "Tayvan｜UVC33 DTF Printer",
    customerStoryCaption22: "Amerika Birleşik Devletleri｜F70Pro DTF Printer",
    customerStoryCaption23: "Amerika Birleşik Devletleri｜2513 UV Printer",
    customerStoryCaption24: "Amerika Birleşik Devletleri｜6090 UV Printer",
    customerStoryCaption25: "Amerika Birleşik Devletleri｜4030 UV Printer",
    customerStoryCaption26: "Amerika Birleşik Devletleri｜3250 UV Printer",
    customerStoryCaption27: "Güney Kore｜4060 UV Printer",
    customerStoryCaption28: "Hollanda｜4060 UV Printer",
    customerStoryCaption29: "Kamboçya｜4030 UV Printer",
    customerStoryCaption30: "Kanada｜F33 DTF Printer",
  },
  vi: {
    customerStoryCountryUsaNewYork: "New York, Hoa Kỳ",
    customerStoryCountryGermany: "Đức",
    customerStoryCountryThailand: "Thái Lan",
    customerStoryCountrySpain: "Tây Ban Nha",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Úc",
    customerStoryCountrySaudiArabia: "Ả Rập Xê-út",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "Hàn Quốc",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Hà Lan",
    customerStoryCountrySweden: "Thụy Điển",
    customerStoryCountrySouthAfrica: "Nam Phi",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Đài Loan",
    customerStoryCountryUsa: "Hoa Kỳ",
    customerStoryCountryCambodia: "Campuchia",
    customerStoryCountryCanada: "Canada",
    customerStoryCaption01: "Hoa Kỳ｜6090 UV Printer",
    customerStoryCaption02: "Đức｜F33 DTF Printer",
    customerStoryCaption03: "Thái Lan｜3250 UV Printer",
    customerStoryCaption04: "Tây Ban Nha｜3250 UV Printer",
    customerStoryCaption05: "Brazil｜2030 UV Printer",
    customerStoryCaption06: "Úc｜F33 DTF Printer",
    customerStoryCaption07: "Ả Rập Xê-út｜2030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "Hàn Quốc｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan｜4030 UV Printer",
    customerStoryCaption12: "Mexico｜4060 UV Printer",
    customerStoryCaption13: "Argentina｜4060 UV Printer",
    customerStoryCaption14: "Philippines｜6090 UV Printer",
    customerStoryCaption15: "Indonesia｜4030 UV Printer",
    customerStoryCaption16: "Hà Lan｜4030 UV Printer",
    customerStoryCaption17: "Thụy Điển｜4060 UV Printer",
    customerStoryCaption18: "Đức｜2030 UV Printer",
    customerStoryCaption19: "Nam Phi｜2030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Đài Loan｜UVC33 DTF Printer",
    customerStoryCaption22: "Hoa Kỳ｜F70Pro DTF Printer",
    customerStoryCaption23: "Hoa Kỳ｜2513 UV Printer",
    customerStoryCaption24: "Hoa Kỳ｜6090 UV Printer",
    customerStoryCaption25: "Hoa Kỳ｜4030 UV Printer",
    customerStoryCaption26: "Hoa Kỳ｜3250 UV Printer",
    customerStoryCaption27: "Hàn Quốc｜4060 UV Printer",
    customerStoryCaption28: "Hà Lan｜4060 UV Printer",
    customerStoryCaption29: "Campuchia｜4030 UV Printer",
    customerStoryCaption30: "Canada｜F33 DTF Printer",
  },
  nl: {
    customerStoryCountryUsaNewYork: "New York, VS",
    customerStoryCountryGermany: "Duitsland",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spanje",
    customerStoryCountryBrazil: "Brazilië",
    customerStoryCountryAustralia: "Australië",
    customerStoryCountrySaudiArabia: "Saoedi-Arabië",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "Zuid-Korea",
    customerStoryCountryIsrael: "Israël",
    customerStoryCountryKazakhstan: "Kazachstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentinië",
    customerStoryCountryPhilippines: "Filipijnen",
    customerStoryCountryIndonesia: "Indonesië",
    customerStoryCountryNetherlands: "Nederland",
    customerStoryCountrySweden: "Zweden",
    customerStoryCountrySouthAfrica: "Zuid-Afrika",
    customerStoryCountryMalaysia: "Maleisië",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "Verenigde Staten",
    customerStoryCountryCambodia: "Cambodja",
    customerStoryCountryCanada: "Canada",
    customerStoryCaption01: "Verenigde Staten｜6090 UV Printer",
    customerStoryCaption02: "Duitsland｜F33 DTF Printer",
    customerStoryCaption03: "Thailand｜3250 UV Printer",
    customerStoryCaption04: "Spanje｜3250 UV Printer",
    customerStoryCaption05: "Brazilië｜2030 UV Printer",
    customerStoryCaption06: "Australië｜F33 DTF Printer",
    customerStoryCaption07: "Saoedi-Arabië｜2030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "Zuid-Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israël｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazachstan｜4030 UV Printer",
    customerStoryCaption12: "Mexico｜4060 UV Printer",
    customerStoryCaption13: "Argentinië｜4060 UV Printer",
    customerStoryCaption14: "Filipijnen｜6090 UV Printer",
    customerStoryCaption15: "Indonesië｜4030 UV Printer",
    customerStoryCaption16: "Nederland｜4030 UV Printer",
    customerStoryCaption17: "Zweden｜4060 UV Printer",
    customerStoryCaption18: "Duitsland｜2030 UV Printer",
    customerStoryCaption19: "Zuid-Afrika｜2030 UV Printer",
    customerStoryCaption20: "Maleisië｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "Verenigde Staten｜F70Pro DTF Printer",
    customerStoryCaption23: "Verenigde Staten｜2513 UV Printer",
    customerStoryCaption24: "Verenigde Staten｜6090 UV Printer",
    customerStoryCaption25: "Verenigde Staten｜4030 UV Printer",
    customerStoryCaption26: "Verenigde Staten｜3250 UV Printer",
    customerStoryCaption27: "Zuid-Korea｜4060 UV Printer",
    customerStoryCaption28: "Nederland｜4060 UV Printer",
    customerStoryCaption29: "Cambodja｜4030 UV Printer",
    customerStoryCaption30: "Canada｜F33 DTF Printer",
  },
  id: {
    customerStoryCountryUsaNewYork: "New York, AS",
    customerStoryCountryGermany: "Jerman",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spanyol",
    customerStoryCountryBrazil: "Brasil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Arab Saudi",
    customerStoryCountrySingapore: "Singapura",
    customerStoryCountryKorea: "Korea Selatan",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Meksiko",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Filipina",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Belanda",
    customerStoryCountrySweden: "Swedia",
    customerStoryCountrySouthAfrica: "Afrika Selatan",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "Amerika Serikat",
    customerStoryCountryCambodia: "Kamboja",
    customerStoryCountryCanada: "Kanada",
    customerStoryCaption01: "Amerika Serikat｜6090 UV Printer",
    customerStoryCaption02: "Jerman｜F33 DTF Printer",
    customerStoryCaption03: "Thailand｜3250 UV Printer",
    customerStoryCaption04: "Spanyol｜3250 UV Printer",
    customerStoryCaption05: "Brasil｜2030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Arab Saudi｜2030 UV Printer",
    customerStoryCaption08: "Singapura｜F33 DTF Printer",
    customerStoryCaption09: "Korea Selatan｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan｜4030 UV Printer",
    customerStoryCaption12: "Meksiko｜4060 UV Printer",
    customerStoryCaption13: "Argentina｜4060 UV Printer",
    customerStoryCaption14: "Filipina｜6090 UV Printer",
    customerStoryCaption15: "Indonesia｜4030 UV Printer",
    customerStoryCaption16: "Belanda｜4030 UV Printer",
    customerStoryCaption17: "Swedia｜4060 UV Printer",
    customerStoryCaption18: "Jerman｜2030 UV Printer",
    customerStoryCaption19: "Afrika Selatan｜2030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "Amerika Serikat｜F70Pro DTF Printer",
    customerStoryCaption23: "Amerika Serikat｜2513 UV Printer",
    customerStoryCaption24: "Amerika Serikat｜6090 UV Printer",
    customerStoryCaption25: "Amerika Serikat｜4030 UV Printer",
    customerStoryCaption26: "Amerika Serikat｜3250 UV Printer",
    customerStoryCaption27: "Korea Selatan｜4060 UV Printer",
    customerStoryCaption28: "Belanda｜4060 UV Printer",
    customerStoryCaption29: "Kamboja｜4030 UV Printer",
    customerStoryCaption30: "Kanada｜F33 DTF Printer",
  },
  ar: {
    customerStoryCountryUsaNewYork: "نيويورك، الولايات المتحدة",
    customerStoryCountryGermany: "ألمانيا",
    customerStoryCountryThailand: "تايلاند",
    customerStoryCountrySpain: "إسبانيا",
    customerStoryCountryBrazil: "البرازيل",
    customerStoryCountryAustralia: "أستراليا",
    customerStoryCountrySaudiArabia: "المملكة العربية السعودية",
    customerStoryCountrySingapore: "سنغافورة",
    customerStoryCountryKorea: "كوريا الجنوبية",
    customerStoryCountryIsrael: "إسرائيل",
    customerStoryCountryKazakhstan: "كازاخستان",
    customerStoryCountryMexico: "المكسيك",
    customerStoryCountryArgentina: "الأرجنتين",
    customerStoryCountryPhilippines: "الفلبين",
    customerStoryCountryIndonesia: "إندونيسيا",
    customerStoryCountryNetherlands: "هولندا",
    customerStoryCountrySweden: "السويد",
    customerStoryCountrySouthAfrica: "جنوب أفريقيا",
    customerStoryCountryMalaysia: "ماليزيا",
    customerStoryCountryTaiwan: "تايوان",
    customerStoryCountryUsa: "الولايات المتحدة",
    customerStoryCountryCambodia: "كمبوديا",
    customerStoryCountryCanada: "كندا",
    customerStoryCaption01: "الولايات المتحدة｜6090 UV Printer",
    customerStoryCaption02: "ألمانيا｜F33 DTF Printer",
    customerStoryCaption03: "تايلاند｜3250 UV Printer",
    customerStoryCaption04: "إسبانيا｜3250 UV Printer",
    customerStoryCaption05: "البرازيل｜2030 UV Printer",
    customerStoryCaption06: "أستراليا｜F33 DTF Printer",
    customerStoryCaption07: "المملكة العربية السعودية｜2030 UV Printer",
    customerStoryCaption08: "سنغافورة｜F33 DTF Printer",
    customerStoryCaption09: "كوريا الجنوبية｜F33 DTF Printer",
    customerStoryCaption10: "إسرائيل｜UVC33 DTF Printer",
    customerStoryCaption11: "كازاخستان｜4030 UV Printer",
    customerStoryCaption12: "المكسيك｜4060 UV Printer",
    customerStoryCaption13: "الأرجنتين｜4060 UV Printer",
    customerStoryCaption14: "الفلبين｜6090 UV Printer",
    customerStoryCaption15: "إندونيسيا｜4030 UV Printer",
    customerStoryCaption16: "هولندا｜4030 UV Printer",
    customerStoryCaption17: "السويد｜4060 UV Printer",
    customerStoryCaption18: "ألمانيا｜2030 UV Printer",
    customerStoryCaption19: "جنوب أفريقيا｜2030 UV Printer",
    customerStoryCaption20: "ماليزيا｜F33 DTF Printer",
    customerStoryCaption21: "تايوان｜UVC33 DTF Printer",
    customerStoryCaption22: "الولايات المتحدة｜F70Pro DTF Printer",
    customerStoryCaption23: "الولايات المتحدة｜2513 UV Printer",
    customerStoryCaption24: "الولايات المتحدة｜6090 UV Printer",
    customerStoryCaption25: "الولايات المتحدة｜4030 UV Printer",
    customerStoryCaption26: "الولايات المتحدة｜3250 UV Printer",
    customerStoryCaption27: "كوريا الجنوبية｜4060 UV Printer",
    customerStoryCaption28: "هولندا｜4060 UV Printer",
    customerStoryCaption29: "كمبوديا｜4030 UV Printer",
    customerStoryCaption30: "كندا｜F33 DTF Printer",
  },
  pl: {
    customerStoryCountryUsaNewYork: "Nowy Jork, USA",
    customerStoryCountryGermany: "Niemcy",
    customerStoryCountryThailand: "Tajlandia",
    customerStoryCountrySpain: "Hiszpania",
    customerStoryCountryBrazil: "Brazylia",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Arabia Saudyjska",
    customerStoryCountrySingapore: "Singapur",
    customerStoryCountryKorea: "Korea Południowa",
    customerStoryCountryIsrael: "Izrael",
    customerStoryCountryKazakhstan: "Kazachstan",
    customerStoryCountryMexico: "Meksyk",
    customerStoryCountryArgentina: "Argentyna",
    customerStoryCountryPhilippines: "Filipiny",
    customerStoryCountryIndonesia: "Indonezja",
    customerStoryCountryNetherlands: "Holandia",
    customerStoryCountrySweden: "Szwecja",
    customerStoryCountrySouthAfrica: "RPA",
    customerStoryCountryMalaysia: "Malezja",
    customerStoryCountryTaiwan: "Tajwan",
    customerStoryCountryUsa: "Stany Zjednoczone",
    customerStoryCountryCambodia: "Kambodża",
    customerStoryCountryCanada: "Kanada",
    customerStoryCaption01: "Stany Zjednoczone｜6090 UV Printer",
    customerStoryCaption02: "Niemcy｜F33 DTF Printer",
    customerStoryCaption03: "Tajlandia｜3250 UV Printer",
    customerStoryCaption04: "Hiszpania｜3250 UV Printer",
    customerStoryCaption05: "Brazylia｜2030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Arabia Saudyjska｜2030 UV Printer",
    customerStoryCaption08: "Singapur｜F33 DTF Printer",
    customerStoryCaption09: "Korea Południowa｜F33 DTF Printer",
    customerStoryCaption10: "Izrael｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazachstan｜4030 UV Printer",
    customerStoryCaption12: "Meksyk｜4060 UV Printer",
    customerStoryCaption13: "Argentyna｜4060 UV Printer",
    customerStoryCaption14: "Filipiny｜6090 UV Printer",
    customerStoryCaption15: "Indonezja｜4030 UV Printer",
    customerStoryCaption16: "Holandia｜4030 UV Printer",
    customerStoryCaption17: "Szwecja｜4060 UV Printer",
    customerStoryCaption18: "Niemcy｜2030 UV Printer",
    customerStoryCaption19: "RPA｜2030 UV Printer",
    customerStoryCaption20: "Malezja｜F33 DTF Printer",
    customerStoryCaption21: "Tajwan｜UVC33 DTF Printer",
    customerStoryCaption22: "Stany Zjednoczone｜F70Pro DTF Printer",
    customerStoryCaption23: "Stany Zjednoczone｜2513 UV Printer",
    customerStoryCaption24: "Stany Zjednoczone｜6090 UV Printer",
    customerStoryCaption25: "Stany Zjednoczone｜4030 UV Printer",
    customerStoryCaption26: "Stany Zjednoczone｜3250 UV Printer",
    customerStoryCaption27: "Korea Południowa｜4060 UV Printer",
    customerStoryCaption28: "Holandia｜4060 UV Printer",
    customerStoryCaption29: "Kambodża｜4030 UV Printer",
    customerStoryCaption30: "Kanada｜F33 DTF Printer",
  },
};
